export default "__VITE_ASSET__4172ab0d__"